import singleChartTpl from './views/single_chart.html';
import './single_chart.scss';
import singleChartCtrl from './controllers/singleChartController';


const name = 'singlechart';
var module = angular.module(name, [

]).component(name, {
    template: singleChartTpl,
    controllerAs: name,
    bindings: {
        graphData: '<',
        showGraph: '<',
        graphWidth: '<',
        graphHeight: '<',
        chartType: '<',
        title: '<',
        subTitle: '<',
        axis:'<',
        header: '<',
        totalCount: '<',
        count: '<',
        colors: '<',
        setLocalImage: '&setimage'
    },
    scope: {
        setLocalImage: '&setimage'
    },
    controller: singleChartCtrl
});

module.constant("CHART_CONSTANTS", {
    DEFAULT_GRAPH_COLORS: ['#3366CC', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#329262', '#5574A6', '#3B3EAC']
});

module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('singlechart', {
            parent: 'app',
            url: '/singlechart',

            views: {
                '@': {
                    template: singleChartTpl,
                    controller: singleChartCtrl,
                    controllerAs: 'singlechart'
                }
            }
        })

});


// WEBPACK FOOTER //
// ./src/app/single_chart/singleChartModule.js